import PropTypes from 'prop-types';

import { FormHelperText, Grid } from '@mui/material';

import { sortByKey } from '../../utils';
import { formatReactSelectValue } from '../Forms/utils';
import { getSelectValue } from './utils';

import StyledSelect from '.';

const ReactSelectInputComponent = (props) => {
  const {
    multi,
    sortAlphabetically,
    options,
    input,
    disabled,
    infoMessage,
    showInfoMessage,
    isClearable,
    placeholder,
    meta: { touched, error },
  } = props;

  const inputValue = input?.value;
  const value = getSelectValue(inputValue, options, multi);

  const sortedOptions = sortAlphabetically
    ? options.sort((a, b) => sortByKey(a, b, 'label'))
    : options;
  const hasError = touched && !!error;

  const hasInfo = infoMessage && showInfoMessage;
  return (
    <Grid container alignItems="center">
      <div style={{ width: '100%' }}>
        <StyledSelect
          value={value}
          onChange={(event, newValue) =>
            input.onChange(formatReactSelectValue(newValue, multi))
          }
          options={sortedOptions}
          multiple={multi}
          disabled={Boolean(disabled)}
          error={hasError}
          disableClearable={!isClearable}
          placeholder={placeholder}
          filterSelectedOptions={multi}
          sortAlphabetically={false} // to do not sort them twice
        />
      </div>

      {(hasError || hasInfo) && (
        <FormHelperText
          component="div"
          error={hasError}
          style={{ margin: '0 1.4rem' }}
        >
          {error || infoMessage}
        </FormHelperText>
      )}
    </Grid>
  );
};

ReactSelectInputComponent.defaultProps = {
  options: [],
  multi: false,
  sortAlphabetically: true,
  infoMessage: null,
  showInfoMessage: false,
  disabled: false,
  isClearable: false,
  placeholder: 'Select...',
};

ReactSelectInputComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  options: PropTypes.instanceOf(Array),
  multi: PropTypes.bool,
  sortAlphabetically: PropTypes.bool,
  infoMessage: PropTypes.string,
  placeholder: PropTypes.string,
  showInfoMessage: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  disabled: PropTypes.any, // should be boolean (converted to it in this component)
  isClearable: PropTypes.bool,
};

export default ReactSelectInputComponent;
